import { DtStatistics } from '@ow/ditto-core'

const { transformer } = DtStatistics

export { transformer }
